import React from 'react';

interface CarveOutRow {
  rate?: number;
}

/**
 * Rate template with currency formatting
 */
export const RateTemplate: React.FC<{ rate: number | null | undefined }> = ({ rate }) => {
  const value = rate ?? 0;
  try {
    return <span>${value.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>;
  } catch {
    return <span>${parseFloat(value.toString() || '0').toFixed(2)}</span>;
  }
};

// Template function for grid column
export const rateTemplate = (props: CarveOutRow) => <RateTemplate rate={props.rate} />;

export default RateTemplate;
